import AdministrativeAgentAdd from './AdministrativeAgentAdd';

export default AdministrativeAgentAdd;
